import { useContext, createContext } from 'react';

export const AuthContext = createContext({
    token: null,
    setToken: (data) => { },
})
export function useAuthContext() {
    return useContext(AuthContext);
}